import React, { Component } from 'react';

import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import Accordion from 'react-bootstrap/Accordion';


class CardInput extends Component {


    featured = [
        '', 
        '',
        '',
        ''
    ]

    componentDidMount(){
        // axios.get(`https://localhost:8086/ohl/poleDetails`, {
        //     params: {
        //         latMin: latMin,
        //         latMax: latMax,
        //         lngMin: lngMin,
        //         lngMax: lngMax
        //     }
        //})
        //.then(res => {
            // let p3 = performance.now();
            // console.log(p3 - p1);
            // //debugger;
            // this.setState({
            //     spansInRangeList: res.data.data.filter(s => s.pole1Latitude > 0 && s.pole2Latitude > 0 && s.pole1Latitude > 0 && s.pole2Latitude > 0),
            //     bounds: { latMin: latMin, latMax: latMax, lngMin: lngMin, lngMax: lngMax },
            //     protectionWiresList: [],
            //     phasesList: []
            // })
            // let p2 = performance.now();

        //})
    }

    render() {
        return (
            <Accordion defaultActiveKey="0">
                <Card>
                    <Accordion.Toggle as={Card.Header} eventKey='0'>
                        <Card.Header /*onClick={() => console.log('vava')}*/>
                            Pole Details
                        {/* <ExpandLess /> */}
                        </Card.Header>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey='0'>
                        <Card.Text>
                            <ListGroup variant="flush">
                                <ListGroup.Item><b>Cras: </b> justo odio</ListGroup.Item>
                                <ListGroup.Item>Dapibus ac facilisis in</ListGroup.Item>
                                <ListGroup.Item>Vestibulum at ero <span >Go</span> </ListGroup.Item>
                            </ListGroup>
                        </Card.Text>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
        )
    }
}


export default CardInput;